import apiService from "./apiService";
import AppConstants from "../appConstants";

class DeletedClientService {
    getall(params) {
        return new Promise((resolve, reject) => {
            apiService.get(AppConstants.URL_DELETED_CLIENT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }

    report(params) {
        return new Promise((resolve, reject) => {
            apiService.downloadFile(AppConstants.URL_DELETED_CLIENT_REPORT, params)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
    
    // =====================================================================
    
}

export default new DeletedClientService();
